import type { FirmLogoFillItem } from "../../../api/firmLogoFill.service.js";
import { PaginationControls } from "../../../components/PaginationControls/index.js";
import { FirmLogoCopyRow } from "./FirmLogoCopyRow.js";
import { rowKeyOf } from "./logoPick.js";
import styles from "./FirmLogoCopy.module.css";

type FirmLogoCopyResultsProps = {
  items: FirmLogoFillItem[];
  page: number;
  pageSize: number;
  totalItems: number;
  expandedRowKey: string | null;
  canPickLogos: boolean;
  onToggleRow: (rowKey: string) => void;
  onPageChange: (page: number) => void;
  onLogoSaved: (item: FirmLogoFillItem, rowKey: string) => Promise<void>;
};

export function lastPageOf(totalItems: number, pageSize: number): number {
  return Math.max(1, Math.ceil(totalItems / pageSize));
}

export function FirmLogoCopyResults({
  items,
  page,
  pageSize,
  totalItems,
  expandedRowKey,
  canPickLogos,
  onToggleRow,
  onPageChange,
  onLogoSaved,
}: FirmLogoCopyResultsProps) {
  const startIndex = (page - 1) * pageSize;

  return (
    <>
      <div className={styles.tableWrapper}>
        <table className={styles.table} aria-label="Planned logo copy">
          <thead>
            <tr>
              <th scope="col">Firm</th>
              <th scope="col">Website</th>
              <th scope="col">Location</th>
              <th scope="col">Outcome</th>
              <th scope="col">Planned logo</th>
              <th scope="col">Logo now</th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => {
              const rowKey = rowKeyOf(item);

              return (
                <FirmLogoCopyRow
                  key={rowKey}
                  item={item}
                  rowKey={rowKey}
                  isExpanded={expandedRowKey === rowKey}
                  canPickLogos={canPickLogos}
                  onToggle={() => onToggleRow(rowKey)}
                  onLogoSaved={() => onLogoSaved(item, rowKey)}
                />
              );
            })}
          </tbody>
        </table>
      </div>
      <PaginationControls
        currentPage={page}
        totalPages={lastPageOf(totalItems, pageSize)}
        startIndex={startIndex}
        endIndex={startIndex + items.length}
        totalCount={totalItems}
        itemName="rows"
        onPageChange={onPageChange}
      />
    </>
  );
}
